<div class="container-fluid py-4">
  <app-route-title
    [iconRef]="'assets/icons/icon-connections.svg'"
    [defaultTitle]="'MY_CONNECTIONS_TITLE'"
    [dataTestId]="'connections-link'"
  ></app-route-title>

  <router-outlet></router-outlet>
</div>
